// extracted by mini-css-extract-plugin
export default {"container_body":"search_container_body__tztDE","loader_wrapper":"search_loader_wrapper__Bf93F"};